import { Component } from '@angular/core';

@Component({
  selector: 'cx-reset-new-password-layout',
  templateUrl: './reset-new-password-layout.component.html',
  styleUrls: ['./reset-new-password-layout.component.scss']
})
export class ResetNewPasswordLayoutComponent {}
